import { VStack } from "@gluestack-ui/themed";
import { Button } from "@repo/core/components/core/Button";

import { useStoreSelectOptionsController } from "./controller";

import { StoreSelectOptionsProps } from "./types";
import { useDeviceType } from "@repo/core/hooks/useDeviceType";
import { SelectControlled } from "@repo/core/components/forms/SelectControlled";
import { StoreSelectorVariantEnum } from "@repo/core/screens/Sales/components/StoreSelector/types";
import { MustShow } from "../../core/MustShow";

export const StoreSelectOptions = ({
  onClose,
  onSelectStoreSuccess,
  storeSelectorVariant = StoreSelectorVariantEnum.BOTH
}: StoreSelectOptionsProps) => {
  const {
    control,
    onSubmitForm,
    availableShopkeepers,
    availableStores,
    onChangeShopkeeper,
    hasMoreThanOneShopkeeper,
    hasMoreThanOneStore
  } = useStoreSelectOptionsController({
    onClose,
    onSelectStoreSuccess
  });

  const { isMobile } = useDeviceType();

  return (
    <VStack flex={1} overflow="hidden" height="$100vh">
      <VStack flex={1} bgColor="$white" h="$full">
        <VStack gap="$4" p="$4" pb="$6" flex={4}>
          <SelectControlled
            control={control}
            name="shopkeeper"
            label="Lojista"
            placeholder="Selecione um lojista"
            options={availableShopkeepers.map((shopkeeper, index) => ({
              label: shopkeeper.descrLojista,
              value: index.toString()
            }))}
            isDisabled={!hasMoreThanOneShopkeeper}
            onChange={(value) => onChangeShopkeeper(value as string)}
          />
          <MustShow
            isVisible={storeSelectorVariant === StoreSelectorVariantEnum.BOTH}
          >
            <SelectControlled
              control={control}
              name="store"
              label="Loja"
              placeholder="Selecione uma loja"
              options={availableStores.map((store, index) => ({
                label: store.descrLoja,
                value: index.toString()
              }))}
              isDisabled={!hasMoreThanOneStore}
            />
          </MustShow>
        </VStack>
        <VStack
          flex={1}
          px="$4"
          flexDirection={isMobile ? "column-reverse" : "row"}
          alignItems={isMobile ? "flex-start" : "flex-end"}
          p={isMobile ? "$0" : "$4"}
          justifyContent={isMobile ? "center" : "flex-end"}
          gap="$2"
        >
          <Button
            w="$full"
            borderRadius={isMobile ? "$md" : "$lg"}
            size={isMobile ? "lg" : "sm"}
            text="Concluir"
            onPress={onSubmitForm}
          />
        </VStack>
      </VStack>
    </VStack>
  );
};
